<template>
    <div class="ui-product" :class="{'card': card, 'small': small}">
        <div class="ui-product-content">
            <ui-badge v-if="unity.number" :text="unity.number" :color="color" design="xxxl" :border="border" />
            <div>
                <div v-if="nameComputed" class="ui-product-title" data-ui="'simulation-div-unity-name'">{{ nameComputed }}</div>
                <div v-if="unityInfoComputed" class="ui-product-subtitle" data-ui="'simulation-div-unity-info'">{{ unityInfoComputed }}</div>
            </div>
            <ui-button data-ui="'simulator-button-open-products'" v-if="editButton" design="line xs rounded" @click="openModal('simulation-product')">Alterar</ui-button>
        </div>
        <div v-if="footer" class="ui-product-footer">
            <div v-add-html="cardFooter" class="ui-product-info"/>
        </div>
    </div> 
</template>

<script>
    import uiBadge from "@/components/ui/badge"
    
    import { uiButton } from "@/components/ui/buttons"

    export default {
        name: 'product-card',

        components: {
            uiBadge,
            uiButton,
        },


        props: {
            product: {
                type: Object,
                required: true,
                default: function () {
                    return {}
                }
            },

            unity: {
                type: Object,
                required: true,
                default: function () {
                    return {}
                }
            },

            footer: {
                type: Boolean,
                required: false,
                default: false,
            },

            card: {
                type: Boolean,
                required: false,
                default: false,
            },

            editButton: {
                type: Boolean,
                required: false,
                default: false,
            },

            small: {
                type: Boolean,
                required: false,
                default: false,
            },

            color: {
                type: String,
                required: false,
                default: '#1bca85',
            },

            border: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        computed: {
            nameComputed() {
                // if(this.small)
                    // console.log(this.product.infos.subtitle);

                return this.product.name
            },

            unityInfoComputed() {
                let info = ''

                switch (this.product.availability.type) {
                    case 'vertical':
                        if (this.unity.infos && this.unity.infos.typology) {
                            if (this.unity.floor == 0) info = `Térreo - `
                            else info = `${this.unity.floor}º andar - `
                            info += `${this.unity.infos.typology} - ` 
                        }

                        if (this.unity.block) info += `Torre ${this.unity.block} - `
                        if (this.unity.garage) info += `Garagem - `
                        if (this.unity.area) info += `${this.unity.area} m²`
                        break

                    default:
                        if (this.unity.block) info += `${this.product?.availability?.infos?.multiProperty?.hideNumberAndBlock == 'true' ? '' : 'Quadra'} ${this.unity.block} - `
                        if (this.unity.infos && this.unity.infos.typology) info += `${this.unity.infos.typology} - `
                        if (this.unity.garage) info += `Garagem - `
                        if (this.unity.area) info += `${this.unity.area} m²`
                        break
                }

                return info
            },

            cardFooter() {
                const moment = require('moment')
                require('moment/locale/pt-br')
                let dateDelivery = moment(this.product.availability.date_delivery).isValid() ? moment(this.product.availability.date_delivery).format("DD [de] MMMM [de] YYYY") : null

                if(this.product && this.product.infos && this.product.infos.subtitle)
                    return this.product.infos.subtitle

                else if(dateDelivery)
                    return 'Data de entrega: ' + dateDelivery

                else
                    return `Condomínio ${this.product.availability.type.charAt(0).toUpperCase()}${this.product.availability.type.substring(1)}`
            }
        },

        methods: {
            /**
             * Mostrar o Modal
             */
            openModal(name) {
                this.$root.$emit('modal-open-' + name)
            },
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>